module.exports = __webpack_public_path__ + "static/media/mental_health.e6b8428c.jpg";